import { infiniteQueryOptions } from '@tanstack/react-query';
import { useDebounce } from './useDebounce';
import { useDataProvider } from 'ra-core';
import { type AdminDataProvider } from '../api/adminDataProvider';
import { type FetchUsersParams } from '../api/customEndpoints/fetchUsers';

export type UserDto = {
  id: number;
  internalId: string;
  displayName: string;
  pictureUrl?: string;
  jobTitle: string;
  department: string;
  region: string;
  units: string[];
};

const DEBOUNCE_DELAY = 300;

export const useGetUsers = ({ limit, query, ...props }: FetchUsersParams) => {
  const dataProvider = useDataProvider<AdminDataProvider>();
  const debouncedQuery = useDebounce(query, DEBOUNCE_DELAY);

  return infiniteQueryOptions({
    queryKey: ['users', { query: debouncedQuery, limit, ...props }],
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      dataProvider.fetchUsers({
        pageParam,
        ...props,
        query: debouncedQuery,
        limit,
      }),
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => lastPage.next,
  });
};
